import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ListDoctorsResponseElement } from '../types/apiGeneratedTypes';

export interface DoctorsPageState {
  searchValue: string;
  appliedFilters: string[];
  isAddDoctorModalOpened: boolean;
  doctorsList: ListDoctorsResponseElement[] | null;
  limit: number;
  doctorDataToEdit: ListDoctorsResponseElement | null;
  doctorsCount: number | null;
}

export const initialState: DoctorsPageState = {
  searchValue: '',
  appliedFilters: [],
  isAddDoctorModalOpened: false,
  doctorsList: null,
  limit: 10,
  doctorDataToEdit: null,
  doctorsCount: null,
};

const doctorsPageSlice = createSlice({
  name: 'doctors',
  initialState,
  reducers: {
    setDoctorsPageSearchValue(state, action: PayloadAction<string>) {
      state.searchValue = action.payload;
    },
    clearDoctorsPageSearchValue(state) {
      state.searchValue = '';
    },
    addFilter(state, action: PayloadAction<string>) {
      state.appliedFilters = [...state.appliedFilters, action.payload];
    },
    deleteFilter(state, action: PayloadAction<string>) {
      state.appliedFilters = state.appliedFilters.filter(
        (el) => el !== action.payload
      );
    },
    clearAllFilters(state) {
      state.appliedFilters = [];
    },
    changeModalVisibility(state, action: PayloadAction<boolean>) {
      state.isAddDoctorModalOpened = action.payload;
    },
    setDoctorDataToEdit(
      state,
      action: PayloadAction<ListDoctorsResponseElement | null>
    ) {
      state.doctorDataToEdit = action.payload;
    },
    setDoctorsList(state, action: PayloadAction<ListDoctorsResponseElement[]>) {
      state.doctorsList = action.payload;
    },
    setDoctorsCount(state, action: PayloadAction<number>) {
      state.doctorsCount = action.payload;
    },
    appendDoctorsList(
      state,
      action: PayloadAction<ListDoctorsResponseElement[]>
    ) {
      if (!state.doctorsList) {
        state.doctorsList = action.payload;
      } else {
        state.doctorsList = [...state.doctorsList, ...action.payload];
      }
    },
  },
});

export const {
  setDoctorsPageSearchValue,
  clearDoctorsPageSearchValue,
  addFilter,
  deleteFilter,
  clearAllFilters,
  changeModalVisibility,
  setDoctorsList,
  appendDoctorsList,
  setDoctorDataToEdit,
  setDoctorsCount,
} = doctorsPageSlice.actions;
export default doctorsPageSlice.reducer;
